import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import { DropdownContext } from './dropdownConstants';
import { KEYHANDLER_DIRECTION } from '../../helpers/constants';
import { Tooltip } from '../Tooltip';
import styles from '@patternfly/react-styles/css/components/Dropdown/dropdown';
export var InternalDropdownItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InternalDropdownItem, _React$Component);

  function InternalDropdownItem() {
    var _this;

    _classCallCheck(this, InternalDropdownItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InternalDropdownItem).apply(this, arguments));
    _this.ref = React.createRef();
    _this.additionalRef = React.createRef();

    _this.getInnerNode = function (node) {
      return node && node.childNodes && node.childNodes.length ? node.childNodes[0] : node;
    };

    _this.onKeyDown = function (event) {
      // Detected key press on this item, notify the menu parent so that the appropriate item can be focused
      var innerIndex = event.target === _this.ref.current ? 0 : 1;

      if (!_this.props.customChild) {
        event.preventDefault();
      }

      if (event.key === 'ArrowUp') {
        _this.props.context.keyHandler(_this.props.index, innerIndex, KEYHANDLER_DIRECTION.UP);
      } else if (event.key === 'ArrowDown') {
        _this.props.context.keyHandler(_this.props.index, innerIndex, KEYHANDLER_DIRECTION.DOWN);
      } else if (event.key === 'ArrowRight') {
        _this.props.context.keyHandler(_this.props.index, innerIndex, KEYHANDLER_DIRECTION.RIGHT);
      } else if (event.key === 'ArrowLeft') {
        _this.props.context.keyHandler(_this.props.index, innerIndex, KEYHANDLER_DIRECTION.LEFT);
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.target.click();
        _this.props.enterTriggersArrowDown && _this.props.context.keyHandler(_this.props.index, innerIndex, KEYHANDLER_DIRECTION.DOWN);
      }
    };

    return _this;
  }

  _createClass(InternalDropdownItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          context = _this$props.context,
          index = _this$props.index,
          isDisabled = _this$props.isDisabled,
          role = _this$props.role,
          customChild = _this$props.customChild;
      var customRef = customChild ? this.getInnerNode(this.ref.current) : this.ref.current;
      context.sendRef(index, [customRef, customChild ? customRef : this.additionalRef.current], isDisabled, role === 'separator');
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props2 = this.props,
          context = _this$props2.context,
          index = _this$props2.index,
          isDisabled = _this$props2.isDisabled,
          role = _this$props2.role,
          customChild = _this$props2.customChild;
      var customRef = customChild ? this.getInnerNode(this.ref.current) : this.ref.current;
      context.sendRef(index, [customRef, customChild ? customRef : this.additionalRef.current], isDisabled, role === 'separator');
    }
  }, {
    key: "extendAdditionalChildRef",
    value: function extendAdditionalChildRef() {
      var additionalChild = this.props.additionalChild;
      return React.cloneElement(additionalChild, {
        ref: this.additionalRef
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /* eslint-disable @typescript-eslint/no-unused-vars */
      var _a = this.props,
          className = _a.className,
          children = _a.children,
          isHovered = _a.isHovered,
          context = _a.context,
          _onClick = _a.onClick,
          component = _a.component,
          role = _a.role,
          isDisabled = _a.isDisabled,
          isPlainText = _a.isPlainText,
          index = _a.index,
          href = _a.href,
          tooltip = _a.tooltip,
          tooltipProps = _a.tooltipProps,
          id = _a.id,
          componentID = _a.componentID,
          listItemClassName = _a.listItemClassName,
          additionalChild = _a.additionalChild,
          customChild = _a.customChild,
          enterTriggersArrowDown = _a.enterTriggersArrowDown,
          icon = _a.icon,
          additionalProps = __rest(_a, ["className", "children", "isHovered", "context", "onClick", "component", "role", "isDisabled", "isPlainText", "index", "href", "tooltip", "tooltipProps", "id", "componentID", "listItemClassName", "additionalChild", "customChild", "enterTriggersArrowDown", "icon"]);
      /* eslint-enable @typescript-eslint/no-unused-vars */


      var Component = component;
      var classes;

      if (Component === 'a') {
        additionalProps['aria-disabled'] = isDisabled;
        additionalProps.tabIndex = isDisabled ? -1 : additionalProps.tabIndex;
      } else if (Component === 'button') {
        additionalProps.disabled = isDisabled;
        additionalProps.type = additionalProps.type || 'button';
      }

      var renderWithTooltip = function renderWithTooltip(childNode) {
        return tooltip ? React.createElement(Tooltip, Object.assign({
          content: tooltip
        }, tooltipProps), childNode) : childNode;
      };

      return React.createElement(DropdownContext.Consumer, null, function (_ref) {
        var onSelect = _ref.onSelect,
            itemClass = _ref.itemClass,
            disabledClass = _ref.disabledClass,
            plainTextClass = _ref.plainTextClass;

        if (_this2.props.role === 'separator') {
          classes = css(icon && styles.modifiers.icon, className);
        } else {
          classes = css(icon && styles.modifiers.icon, className, isDisabled && disabledClass, isPlainText && plainTextClass, itemClass);
        }

        if (customChild) {
          return React.cloneElement(customChild, {
            ref: _this2.ref,
            onKeyDown: _this2.onKeyDown
          });
        }

        return React.createElement("li", {
          className: listItemClassName || null,
          role: role,
          onKeyDown: _this2.onKeyDown,
          onClick: function onClick(event) {
            if (!isDisabled) {
              _onClick(event);

              onSelect(event);
            }
          },
          id: id
        }, renderWithTooltip(React.isValidElement(component) ? React.cloneElement(component, {
          className: css(component.props.className, classes)
        }) : React.createElement(Component, Object.assign({}, additionalProps, {
          href: href,
          ref: _this2.ref,
          className: classes,
          id: componentID
        }), icon && React.createElement("span", {
          className: css(styles.dropdownMenuItemIcon)
        }, icon), children)), additionalChild && _this2.extendAdditionalChildRef());
      });
    }
  }]);

  return InternalDropdownItem;
}(React.Component);
InternalDropdownItem.defaultProps = {
  className: '',
  isHovered: false,
  component: 'a',
  role: 'none',
  isDisabled: false,
  isPlainText: false,
  tooltipProps: {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onClick: function onClick(event) {
    return undefined;
  },
  index: -1,
  context: {
    keyHandler: function keyHandler() {},
    sendRef: function sendRef() {}
  },
  enterTriggersArrowDown: false,
  icon: null
};